import React, {useState} from 'react'
import { useTranslation } from "react-i18next";
import { Card, Row } from "react-bootstrap"
import StadisticCard from './StadisticCard';
import SidePanelViewUsers from '../../SidePanelViewUsers';
import { isNullUndefined } from '../../../../../common/Helpers';

function BookStadistic(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    //const inputParam_ObjectMessageList = props.objectMessageList;
    const inputParam_ObjectMessageList = props.objMessageList !== null && props.objMessageList !== undefined ? props.objMessageList.data.data : null;
    const inputParam_UserProps = props.userProps !== null && props.userProps !== undefined ? props.userProps : null;
    const inputParam_SetterSelectedItem = props.setterSelectedItem !== null && props.setterSelectedItem !== undefined ? props.setterSelectedItem : null;
    const inputParam_SelectedItem = props.selectedItem !== null && props.selectedItem !== undefined ? props.selectedItem : null;
    
    const [isPanelViewUsersOpen, setIsPanelViewUsersOpen] = useState(false);
    
    let draftItemsList = [];
    let toVisaItemsList = [];
    let expiredItemsList = [];
    let sendedItemsList = [];
    let receivedItemsList = [];
    let unReadedItemsList = [];
    let pendingItemsList = [];
    let pendingWaiting = [];
    let expiredWaiting = [];

    if (inputParam_ObjectMessageList !== null) {
        for (let index = 0; index < inputParam_ObjectMessageList.length; index++) {
            const element = inputParam_ObjectMessageList[index];
            if (element.l_items.filter(x => x.item_message.isInPreparation === true).length > 0)
                draftItemsList = draftItemsList.concat(element.l_items.filter(x => !isNullUndefined(x.item_message.isInPreparation) ? x.item_message.isInPreparation === true : false));
            if (element.l_items.filter(x => x.item_message.isInToVisa === true).length > 0)
                toVisaItemsList = toVisaItemsList.concat(element.l_items.filter(x => !isNullUndefined(x.item_message.isInToVisa) ? x.item_message.isInToVisa === true : false));



            if (element.l_items.filter(x => x.item_message.isExpired === true).length > 0)
                expiredItemsList = expiredItemsList.concat(element.l_items.filter(x => x.item_message.isExpired === true));
            if (element.l_items.filter(x => x.item_message.isSent === true).length > 0)
                sendedItemsList = sendedItemsList.concat(element.l_items.filter(x => x.item_message.isSent === true));
            if (element.l_items.filter(x => x.item_message.isReceived === true))
                receivedItemsList = receivedItemsList.concat(element.l_items.filter(x => x.item_message.isReceived === true));
            if (element.l_items.filter(x => x.item_message.isUnread === true).length > 0)
                unReadedItemsList = unReadedItemsList.concat(element.l_items.filter(x => x.item_message.isUnread === true));
            if (element.l_items.filter(x => x.item_message.isPending === true).length > 0)
                pendingItemsList = pendingItemsList.concat(element.l_items.filter(x => x.item_message.isPending === true));

            if (element.l_items.filter(x => x.item_message.isPendingWaiting === true).length > 0)
                pendingWaiting = pendingWaiting.concat(element.l_items.filter(x => x.item_message.isPendingWaiting === true));
            if (element.l_items.filter(x => x.item_message.isExpiredWaiting === true).length > 0)
                expiredWaiting = expiredWaiting.concat(element.l_items.filter(x => x.item_message.isExpiredWaiting === true));
        }
    }

    const container = {
        display: "flex",
        justifyContent: "center",
        margin: "0"
    };

    const cards = [
        { class: "col", title: t('data-lang-lbl-totalmessages'), type: "isTotalMessage", amount: (receivedItemsList.length + sendedItemsList.length), icon: "CreateMailRule", color: "#a1a1a1", display: true },
        
        { class: "col", title: t('data-lang-lbl-draft'), type: "isInPreparation", amount: (draftItemsList.length + toVisaItemsList.length), icon: "MailOptions", color: "#FF7F7F", display: true },
        { class: "col", title: t('data-lang-lbl-tovisa'), type: "isInToVisa", amount: toVisaItemsList.length, icon: "MailCheck", color: "#ffa97f", display: true },
        
        { class: "col", title: t('data-lang-lbl-receivedmessages'), type: "isReceived", amount: receivedItemsList.length, icon: "Mail", color: "#7FD7A7", display: true },
        { class: "col", title: t('data-lang-lbl-sendedmessages'), type: "isSent", amount: sendedItemsList.length, icon: "Send", color: "#A1B8E1", display: true },
        { class: "col", title: t('data-lang-lbl-unreadedmessages'), type: "isUnread", amount: unReadedItemsList.length, icon: "MailAlert", color: "#bdbd63", display: true },
        { class: "col", title: t('data-lang-lbl-pendingmessages'), type: "isPending", amount: pendingItemsList.length, icon: "EventDateMissed12", color: "#ffa97f", display: true },
        { class: "col", title: t('data-lang-lbl-expiredmessages'), type: "isExpired", amount: expiredItemsList.length, icon: "Calories", color: "#FF7F7F", display: true },

        { class: "col", title: t('data-lang-lbl-pendingwaiting-short'), type: "isPendingWaiting", amount: pendingWaiting.length, icon: "DateTime", color: "#FF7F7F", display: true },
        { class: "col", title: t('data-lang-lbl-expiredwaiting-short'), type: "isExpiredWaiting", amount: expiredWaiting.length, icon: "Clock", color: "#FF7F7F", display: true },
    ];

    const setSelectedItem = (item) => {
        inputParam_SetterSelectedItem && inputParam_SetterSelectedItem(item);
    } 

    //Constante resagada, esto dado que deben existir los eventos del comonente para poder ser invocados en array de toolbar.

    return (
        <Card.Body className='p-0'>
            <Row style={ container }>
                <Row className="d-flex mx-auto p-0">
                    <div className={`col d-unset }`} style={{padding: "0px", minWidth: "120px"}} >
                        <div style={{cursor: "pointer"}}>
                            <div style={{display: "block" }}>
                                <h6><b>{ t('data-lang-boxname-bookstadistic') }</b></h6>
                            </div>
                        </div>
                    </div>
                </Row>
                <Row className="d-flex mx-auto p-0">
                    {
                        cards.map((card, index) => (
                            card.display &&
                            <div key={index} className={`${card.class} ${card.display ? "d-unset" : "d-none"}`} style={{padding: "0px", minWidth: "70px"}} >
                                <StadisticCard item={ card } arrayLength={ 9 } index={index} selectedItem={inputParam_SelectedItem} setterSelectedItem={setSelectedItem} />
                            </div>
                        ))
                    }
                </Row>
            </Row>
            {
                inputParam_UserProps.username !== null &&
                <SidePanelViewUsers partyId={ inputParam_UserProps.partyId } isPanelOpen={ isPanelViewUsersOpen } setterIsPanelOpen={ setIsPanelViewUsersOpen } getBookList={false} />
            }
        </Card.Body>
    );
}

export default BookStadistic;

